import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';

import Avatar from 'src/components/avatar';
import Button from 'src/components/buttons/button';
import { onWriteClick } from 'src/modules/community/shared/components/writeButton';
import { showSignupModal, showModal } from 'src/modules/shared/modal/actions';
import { followCommunity } from 'src/modules/community/shared/actions';
import { connect } from 'react-redux';

import linkUtils from 'src/utils/linkUtils';

const CommunityFooterCTA = ({ community, currentUser, followCommunity, showSignupModal, showModal }) => {
  return (
    <a
      className="community__footer-cta"
      href="#"
      onClick={e => {
        e.preventDefault();
        onWriteClick({ community, currentUser, followCommunity, showSignupModal, showModal, trackingSection: 'community-home' });
      }}
    >
      {currentUser && (
        <div className="community__footer-cta__avatar">
          <Avatar size="small" src={linkUtils.generateAvatarLinkFromHash(currentUser.userImageHash)} />
        </div>
      )}
      <div>
        {i18n.t('Write a post or ask a question')}
      </div>
      <div className="community__footer-cta__button">
        <Button
          icon="pencil-1"
        >
          <span className="hidden-xs">{i18n.t('Write')}</span>
        </Button>
      </div>
    </a>
  );
};

CommunityFooterCTA.propTypes = {
  community: PropTypes.object.isRequired,
  currentUser: PropTypes.object,
  showModal: PropTypes.func,
  showSignupModal: PropTypes.func,
};

CommunityFooterCTA.defaultProps = {
  currentUser: null,
  showModal: () => {},
  showSignupModal: () => {},
};

export default connect(null, { showSignupModal, showModal, followCommunity })(CommunityFooterCTA);
